/**
*   Rebuy: Cart Change
*   reference: https://developers.rebuyengine.com/reference/cart-methods
*/
document.addEventListener('rebuy:cart.change', function(event) {
    /**
    *   Update Pillow Quantity
    *   Sets the pillow quantity when items in the cart have changed
    */
    function updateFreePillowsQuantity() {
        const Cart      = window.Rebuy.Cart;
        let productIds  = [7007705399339, 4472568447019, 1811177930795, 6551185293355];
        let { cart }    = event.detail.cart;

        if (!cart) return;

        let eligibleProducts = cart.items.filter((item) => productIds.includes(item.product_id));

        eligibleProducts.forEach(product => {
            let matchingPillow  = cart.items.find((item) => Number(item.properties.mattress) == product.variant_id);
            let updatedQuantity = product.quantity * 2;

            if (!matchingPillow) return;

            if (matchingPillow.quantity !== updatedQuantity) {
                Cart.changeItem({ id: matchingPillow.key, quantity: updatedQuantity });
            }
        });
    }

    updateFreePillowsQuantity();
});